import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "@project/components/Breadcrumb";
import DynamicContainer from "@project/templates/home/DynamicContainer";
import SectionContainer from "@project/templates/home/SectionContainer";
const Presentation = (props) => {
    const { page, children } = props;
    const { contents } = page || {};
    const isTemplateHome = page?.template === "HOME";
    const { title, shortDescription, presentationDynamic } = contents || {};
    return (_jsx(Box, { "data-dark": true, sx: {
            position: "relative",
            backgroundImage: {
                xs: "url('/pattern-mobile.svg')",
                md: "url('/pattern.svg')",
            },
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundColor: "background.header",
            "&::before": {
                content: '""',
                position: "absolute",
                background: {
                    xs: "linear-gradient(0deg, rgba(0, 0, 255, 0.5) 0%, rgba(0, 0, 255, 0.6) 4%, rgba(0, 0, 255, 0.7) 20%, rgba(0, 0, 255, 0.9) 30%, #0000FF 40%, #0000FF 100%)",
                    md: "linear-gradient(90deg, rgba(0, 0, 255, 0.4) 0%, rgba(0, 0, 255, 0.76) 15%, rgba(0, 0, 255, 0.9) 30%, rgba(0, 0, 255, 0.92) 42%, #0000FF 48%, #0000FF 52%, rgba(0, 0, 255, 0.92) 58%, rgba(0, 0, 255, 0.9) 70%, rgba(0, 0, 255, 0.76) 85%, rgba(0, 0, 255, 0.45) 100%)",
                    xl: "linear-gradient(90deg, rgba(0, 0, 255, 0.3) 0%, rgba(0, 0, 255, 0.6) 12%, rgba(0, 0, 255, 0.88) 25%, rgba(0, 0, 255, 0.92) 38%, rgba(0, 0, 255, 0.92) 46%, #0000FF 49%, #0000FF 51%, rgba(0, 0, 255, 0.92) 54%, rgba(0, 0, 255, 0.92) 62%, rgba(0, 0, 255, 0.88) 75%, rgba(0, 0, 255, 0.6) 88%, rgba(0, 0, 255, 0.3) 100%)",
                },
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                inset: 0,
            },
        }, children: _jsx(SectionContainer, { hasDarkBackground: true, sxContainer: {
                py: { xs: "68px", md: "100px" },
                px: {
                    xs: "24px !important",
                    md: "72px !important",
                    "@media (min-width: 1440px)": {
                        px: "100px !important",
                    },
                },
                "& *": {
                    zIndex: 1,
                },
            }, children: _jsxs(Stack, { direction: "row", sx: {
                    alignItems: "center",
                    gap: 6,
                }, children: [_jsxs(Stack, { spacing: 3, sx: {
                            alignItems: { xs: "center", lg: "flex-start" },
                            textAlign: { xs: "center", lg: "left" },
                            justifyContent: "center",
                            margin: { xs: "0 auto", lg: 0 },
                            flex: 1,
                        }, children: [_jsxs(Stack, { spacing: 3, sx: {
                                    alignItems: { xs: "center", lg: "flex-start" },
                                    maxWidth: "700px",
                                    "& *": {
                                        color: "primary.contrastText",
                                    },
                                }, children: [!isTemplateHome && _jsx(Breadcrumb, {}), _jsx(Box, { sx: {
                                            // On utilise ckeditor pour le titre (pour avoir une graisse différente sur certains mots),
                                            // donc on doit forcer le margin à 0 pour éviter d'avoir un margin par défaut sur les h1, h2, h3, h4, h5 et h6.
                                            "& :is(h1, h2, h3, h4, h5, h6)": {
                                                margin: "0px !important",
                                            },
                                            maxWidth: { xs: "100%", md: "690px" },
                                        }, children: title }), _jsx(Box, { sx: {
                                            marginBottom: { xs: "12px", md: "16px" },
                                        }, children: shortDescription })] }), _jsx(DynamicContainer, { children: presentationDynamic })] }), children] }) }) }));
};
export default Presentation;
